import { render, staticRenderFns } from "./dismission.vue?vue&type=template&id=2fcd316c&scoped=true"
import script from "./dismission.vue?vue&type=script&lang=js"
export * from "./dismission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd316c",
  null
  
)

export default component.exports